import { render } from "./MMAddMembersResource.vue?vue&type=template&id=2d580ba8"
import script from "./MMAddMembersResource.vue?vue&type=script&lang=js"
export * from "./MMAddMembersResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__